<div class="relative">
  <!-- Trigger: calendar icon + today's date -->
  <button (click)="toggle()"
    class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-sm text-gray-600 hover:bg-gray-100 transition-colors">
    <span class="relative flex">
      <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      @if (overdueCount > 0) {
      <span class="absolute -top-1.5 -right-1.5 min-w-[15px] h-[15px] px-1 flex items-center justify-center text-[9px] font-bold text-white bg-rose-500 rounded-full ring-2 ring-white">{{ overdueCount }}</span>
      }
    </span>
    <span class="hidden sm:inline">{{ today | date:'EEE d MMM' }}</span>
  </button>

  @if (isOpen) {
  <div class="absolute right-0 mt-2 w-80 bg-white rounded-2xl shadow-lg border border-gray-200 p-3 z-[100]">
    <!-- Month navigation -->
    <div class="flex items-center justify-between mb-2">
      <button (click)="prevMonth()" class="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <span class="text-sm font-semibold text-gray-800 capitalize">{{ monthLabel }}</span>
      <button (click)="nextMonth()" class="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <!-- Weekday header -->
    <div class="grid grid-cols-7 mb-1">
      @for (w of weekdays; track $index) {
      <div class="text-[11px] font-semibold text-gray-400 text-center py-1">{{ w }}</div>
      }
    </div>

    <!-- Day grid -->
    <div class="grid grid-cols-7 gap-0.5">
      @for (cell of cells; track $index) {
      @if (cell) {
      <button (click)="select(cell)"
        class="relative h-8 rounded-lg text-sm flex items-center justify-center transition-colors"
        [class.bg-blue-600]="isToday(cell.key)" [class.text-white]="isToday(cell.key)"
        [class.font-semibold]="isToday(cell.key)"
        [class.bg-blue-100]="isSelected(cell.key) && !isToday(cell.key)"
        [class.text-blue-700]="isSelected(cell.key) && !isToday(cell.key)"
        [class.text-gray-700]="!isToday(cell.key) && !isSelected(cell.key)"
        [class.hover:bg-gray-100]="!isToday(cell.key) && !isSelected(cell.key)">
        {{ cell.day }}
        @if (cell.hasDue) {
        <span class="absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
          [class.bg-white]="isToday(cell.key)"
          [class.bg-rose-500]="cell.overdue && !isToday(cell.key)"
          [class.bg-blue-400]="!cell.overdue && !isToday(cell.key)"></span>
        }
      </button>
      } @else {
      <div class="h-8"></div>
      }
      }
    </div>

    <!-- Selected day's items -->
    <div class="border-t border-gray-100 mt-3 pt-3">
      <p class="text-xs font-semibold text-gray-500 mb-2 capitalize">{{ selectedLabel }}</p>
      <div class="max-h-40 overflow-y-auto">
        @for (t of selectedTodos; track t.id) {
        <button (click)="openTodo(t)"
          class="w-full flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-50 text-left">
          <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
            [class.bg-rose-500]="t.priority === 'HIGH'" [class.bg-amber-500]="t.priority === 'MEDIUM'"
            [class.bg-gray-300]="t.priority !== 'HIGH' && t.priority !== 'MEDIUM'"></span>
          <span class="text-sm text-gray-700 truncate">{{ t.name }}</span>
        </button>
        } @empty {
        <p class="text-sm text-gray-400 py-2 text-center">Nothing due this day</p>
        }
      </div>
    </div>
  </div>
  }
</div>
